<div class="form-field {{ formControl.status | lowercase }}">
	<label *ngIf="label"
		>{{ label }} <span class="required" *ngIf="requiredIcon">*</span>
		<span class="tooltip" *ngIf="hint" [matTooltip]="hint" [matTooltipPosition]="'right'"></span
	></label>
	<div class="form-input-container {{ iconPosition }} {{ type }}">
		<mat-icon class="form-field-icon" *ngIf="hasIcon">{{ icon }}</mat-icon>
		<input
			[type]="type === 'urlTitle' ? 'text' : type"
			[readonly]="readonly"
			[name]="name"
			[placeholder]="placeholder"
			[formControl]="formControl"
			[autocomplete]="type === 'password' ? 'new-password' : 'off'"
      (blur)="onTouched()"
			(click)="click.emit($event)"
			(keydown)="keydown.emit($event)"
			(mousedown)="$event.stopPropagation()"
			[ngClass]="{ 'invalid-input': invalid }" />

		<mat-icon class="append-icon" *ngIf="copy && formControl.value" (click)="copyToClipboard()">content_copy</mat-icon>
	</div>
	<div>
		<span class="invalid-input-message" *ngIf="invalidMessage">{{ invalidMessage | translate }}</span>
	</div>
</div>
